$ = require 'jquery'
SelectMemberView = require 'views/member/select-member-view'
Util = require 'lib/util'
View = require 'view'

module.exports = class MemberSearchResultView extends View
  tagName: 'li'
  className: 'search-result-member'

  events:
    'mouseenter .js-select-member': 'hoverMember'
    'mouseleave .js-select-member': 'blurMember'

  render: ->
    @$el.empty()
    @appendSubview(@subview(SelectMemberView, @model, linkName: true))
    @

  blurMember: (e) ->
    elem = $(e.target).closest('.item').removeClass('selected')
    return

  hoverMember: (e) ->
    elem = $(e.target).closest('.item')
    Util.selectMenuItem($(e.target).closest('.js-list'), '.item', elem)
    return



// WEBPACK FOOTER //
// ./app/scripts/views/search/member-search-result-view.coffee